import styled from 'styled-components'

export const Container = styled.div`
  min-width: 640px;
  width: 960px;
`

export const LabelRow = styled.div`
  display: grid;
  grid-template-columns: 3fr 3fr 2fr 100px;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin: 0px 10px;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 7px;
`
